import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Axios from "../../../axios/axios";
import imageCompression from "browser-image-compression";
import { toast } from "react-toastify";
import SupplierNavbar from "../Admin/SuppplierNavbar";
import SupplierSidebar from "../Admin/SupplierSidebar";
function RentalEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
const loggedInSupplier = JSON.parse(localStorage.getItem("supplier"));

  // Rental state
  const [rental, setRental] = useState({
    rentalItem: "",
    partNo: "",
    description: "",
    brandId: "",
    modelId: "",
    categoryId: "",
    regionId: "",
    year: "",
    rentalType: "",
    rentPricePerDay: "",
    rentPricePerWeek: "",
    rentPricePerMonth: "",
    depositAmount: "",
    availabilityStatus: "Available",
    condition: "Good",
    manufactureDate: "",
    features: [],
    certifications: [],
    images: [],
    supplier: {
      supplierId: "",
      name: "",
      location: "",
      contactNumber: "",
      email: "",
    },
  });

  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [categories, setCategories] = useState([]);
  const [regions, setRegions] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [certifications, setCertifications] = useState([]);
const [sidebarOpen, setSidebarOpen] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);

  const [inputValues, setInputValues] = useState({
    feature: "",
    certification: "",
  });
  const [errors, setErrors] = useState({
    feature: "",
    certification: "",
  });

  // fetch dropdowns + rental details
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [brandRes, modelRes, categoryRes, regionRes, supplierRes, rentalRes] =
          await Promise.all([
            Axios.get("/brands"),
            Axios.get("/models"),
            Axios.get("/categories"),
            Axios.get("/regions"),
            Axios.get("/supplier"),
            Axios.get(`/rental/get/${id}`),
          ]);

        setBrands(brandRes.data);
        setModels(modelRes.data);
        setCategories(categoryRes.data);
        setRegions(regionRes.data);
        setSuppliers(supplierRes.data.data);

        setRental({
          ...rentalRes.data,
          brandId: rentalRes.data.brandId?._id || "",
          modelId: rentalRes.data.modelId?._id || "",
          categoryId: rentalRes.data.categoryId?._id || "",
          regionId: rentalRes.data.regionId?._id || "",
        supplier: loggedInSupplier || rentalRes.data.supplier, 
        });
      } catch (err) {
        console.error("Error fetching data:", err);
        toast.error("Failed to load rental details");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "supplierId") {
      const selectedSupplier = suppliers.find((sup) => sup._id === value);
      setRental((prev) => ({
        ...prev,
        supplier: {
          supplierId: value,
          name: selectedSupplier?.supplierName || "",
          location: selectedSupplier?.address || "",
          contactNumber: selectedSupplier?.phoneNumber || "",
          email: selectedSupplier?.emailAddress || "",
        },
      }));
    } else {
      setRental((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Features / Certifications add/remove
  const handleAdd = (key) => {
    if (!inputValues[key]?.trim()) {
      setErrors({ ...errors, [key]: "Enter something!" });
      return;
    }

    setRental((prev) => ({
      ...prev,
      [key + "s"]: [...prev[key + "s"], inputValues[key]],
    }));

    setInputValues({ ...inputValues, [key]: "" });
    setErrors({ ...errors, [key]: "" });
  };

  const handleRemove = (key, index) => {
    setRental((prev) => {
      const updated = [...prev[key + "s"]];
      updated.splice(index, 1);
      return { ...prev, [key + "s"]: updated };
    });
  };

  // Image Upload
  const uploadFileHandler = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    setUploading(true);

    try {
      const uploadedImages = await Promise.all(
        Array.from(files).map(async (file) => {
          const compressedFile = await imageCompression(file, {
            maxSizeMB: 0.2,
            maxWidthOrHeight: 800,
          });

          const formData = new FormData();
          formData.append("image", compressedFile);

          const { data } = await Axios.post("/upload-multiple", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          return { name: file.name, url: data.fileUrls[0] };
        })
      );

      setRental((prev) => ({
        ...prev,
        images: [...prev.images, ...uploadedImages],
      }));
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Image upload failed");
    } finally {
      setUploading(false);
    }
  };

  const removeImage = (index) => {
    setRental((prev) => {
      const updated = [...prev.images];
      updated.splice(index, 1);
      return { ...prev, images: updated };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await Axios.put(`/rental/update/${id}`, rental);
      toast.success("Rental updated successfully!");
      navigate("/SupplierProducts");
    } catch (err) {
      console.error("Update failed:", err);
      toast.error("Failed to update rental");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
     <div className="enhanced-body">
      <SupplierNavbar
        supplier={suppliers}
        setSupplier={setSuppliers}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
    <div className="card p-4" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      <h4>Edit Rental</h4>
      <form onSubmit={handleSubmit}>
        {/* Rental Item */}
        <div className="form-group">
          <label>Rental Item</label>
          <input
            type="text"
            name="rentalItem"
            value={rental.rentalItem}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

        {/* Part No */}
        <div className="form-group">
          <label>Part No</label>
          <input
            type="text"
            name="partNo"
            value={rental.partNo}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

        {/* Description */}
        <div className="form-group">
          <label>Description</label>
          <textarea
            name="description"
            value={rental.description}
            onChange={handleChange}
            className="form-control"
          ></textarea>
        </div>

       {/* Dropdowns (Brand, Model, Category, Region, Supplier) */}
<div className="form-group">
  <label>Brand</label>
  <select
    name="brandId"
    value={rental.brandId || ""}
    onChange={handleChange}
    className="form-control"
  >
    <option value="">Select Brand</option>
    {brands.map((brand) => (
      <option key={brand._id} value={brand._id}>
        {brand.name}
      </option>
    ))}
  </select>
</div>

<div className="form-group">
  <label>Model</label>
  <select
    name="modelId"
    value={rental.modelId || ""}
    onChange={handleChange}
    className="form-control"
  >
    <option value="">Select Model</option>
    {models.map((model) => (
      <option key={model._id} value={model._id}>
        {model.name}
      </option>
    ))}
  </select>
</div>

<div className="form-group">
  <label>Category</label>
  <select
    name="categoryId"
    value={rental.categoryId || ""}
    onChange={handleChange}
    className="form-control"
  >
    <option value="">Select Category</option>
    {categories.map((cat) => (
      <option key={cat._id} value={cat._id}>
        {cat.name}
      </option>
    ))}
  </select>
</div>

<div className="form-group">
  <label>Region</label>
  <select
    name="regionId"
    value={rental.regionId || ""}
    onChange={handleChange}
    className="form-control"
  >
    <option value="">Select Region</option>
    {regions.map((region) => (
      <option key={region._id} value={region._id}>
        {region.name}
      </option>
    ))}
  </select>
</div>

<div className="form-group">
  <label>Supplier</label>
  <input
    type="text"
    className="form-control"
    value={rental.supplier?.name || ""}
    readOnly
  />
</div>


        {/* Pricing */}
        <div className="form-group">
          <label>Rent Price Per Day</label>
          <input
            type="number"
            name="rentPricePerDay"
            value={rental.rentPricePerDay}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

       {/* Similar fields for rentPricePerWeek, rentPricePerMonth, depositAmount */}
<div className="form-group">
  <label>Rent Price (per Week)</label>
  <input
    type="number"
    name="rentPricePerWeek"
    value={rental.rentPricePerWeek || ""}
    onChange={handleChange}
    className="form-control"
  />
</div>

<div className="form-group">
  <label>Rent Price (per Month)</label>
  <input
    type="number"
    name="rentPricePerMonth"
    value={rental.rentPricePerMonth || ""}
    onChange={handleChange}
    className="form-control"
  />
</div>

<div className="form-group">
  <label>Deposit Amount</label>
  <input
    type="number"
    name="depositAmount"
    value={rental.depositAmount || ""}
    onChange={handleChange}
    className="form-control"
  />
</div>
        {/* Availability Status */}
        <div className="form-group">
          <label>Availability Status</label>
          <select
            name="availabilityStatus"
            value={rental.availabilityStatus}
            onChange={handleChange}
            className="form-control"
          >
            <option value="Available">Available</option>
            <option value="Rented">Rented</option>
            <option value="Under Maintenance">Under Maintenance</option>
          </select>
        </div>

        {/* Condition */}
        <div className="form-group">
          <label>Condition</label>
          <select
            name="condition"
            value={rental.condition}
            onChange={handleChange}
            className="form-control"
          >
            <option value="New">New</option>
            <option value="Good">Good</option>
            <option value="Average">Average</option>
            <option value="Needs Repair">Needs Repair</option>
          </select>
        </div>

        {/* Features */}
        <div className="form-group">
          <label>Features</label>
          <div className="d-flex">
            <input
              type="text"
              className="form-control"
              placeholder="Add feature"
              value={inputValues.feature}
              onChange={(e) =>
                setInputValues({ ...inputValues, feature: e.target.value })
              }
            />
            <button
              type="button"
              className="btn btn-primary mx-2"
              onClick={() => handleAdd("feature")}
            >
              Add
            </button>
          </div>
          <ul>
            {rental.features.map((f, i) => (
              <li key={i}>
                {f}{" "}
                <button
                  type="button"
                  onClick={() => handleRemove("feature", i)}
                  className="btn btn-danger btn-sm"
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>

       {/* Certifications (similar to features) */}
<div className="form-group">
  <label>Certifications</label>
  <select
    multiple
    name="certifications"
    value={rental.certifications || []}
    onChange={(e) =>
      setRental({
        ...rental,
        certifications: Array.from(
          e.target.selectedOptions,
          (opt) => opt.value
        ),
      })
    }
    className="form-control"
  >
    {certifications.map((cert) => (
      <option key={cert._id} value={cert._id}>
        {cert.certificationName}
      </option>
    ))}
  </select>
</div>

        {/* Images */}
        <div className="form-group">
          <label>Images</label>
          <input
            type="file"
            multiple
            onChange={uploadFileHandler}
            accept="image/*"
          />
          <div className="d-flex gap-2 mt-2">
            {rental.images.map((img, i) => (
              <div key={i} className="position-relative">
                <img src={img.url} alt={img.name} height="80" />
                <button
                  type="button"
                  className="btn btn-danger btn-xs"
                  onClick={() => removeImage(i)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Submit */}
        <button type="submit" className="btn btn-primary">
          Update Rental
        </button>
      </form>
    </div>
    </div>
    </div>
    </div>
    </div>
  );
}

export default RentalEdit;
